const ICONS = {
    close: (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                fill="#000"
            />
        </svg>
    ),
    check: (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.7365 3.96967C13.0255 3.67678 13.4942 3.67678 13.7832 3.96967C14.0687 4.25897 14.0722 4.72582 13.7937 5.01947L7.88025 12.0097C7.87456 12.0169 7.86848 12.0238 7.86205 12.0303C7.573 12.3232 7.10437 12.3232 6.81532 12.0303L3.21678 8.38388C2.92774 8.09099 2.92774 7.61612 3.21678 7.32322C3.50583 7.03033 3.97446 7.03033 4.26351 7.32322L7.31638 10.4167L12.7169 3.9921C12.723 3.98424 12.7295 3.97674 12.7365 3.96967Z"
                fill="#000"
            />
        </svg>
    ),
    'double-check': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.96963 4.96967C9.26253 4.67678 9.7374 4.67678 10.0303 4.96967C10.3196 5.25897 10.3231 5.72582 10.0409 6.01947L6.04873 11.0097C6.04297 11.0169 6.03682 11.0238 6.03029 11.0303C5.7374 11.3232 5.26253 11.3232 4.96963 11.0303L2.32319 8.38388C2.03029 8.09099 2.03029 7.61612 2.32319 7.32322C2.61608 7.03033 3.09095 7.03033 3.38385 7.32322L5.47737 9.41674L8.94974 4.9921C8.95592 4.98424 8.96256 4.97674 8.96963 4.96967Z"
                fill="#000"
            />
            <path
                d="M8.04921 10.1099L8.96963 11.0303C9.26253 11.3232 9.7374 11.3232 10.0303 11.0303C10.0368 11.0238 10.043 11.0169 10.0487 11.0097L14.0409 6.01947C14.3231 5.72582 14.3196 5.25897 14.0303 4.96967C13.7374 4.67678 13.2625 4.67678 12.9696 4.96967C12.9626 4.97674 12.9559 4.98424 12.9497 4.9921L9.47737 9.41674L8.99202 8.9314L8.04921 10.1099Z"
                fill="#000"
            />
        </svg>
    ),
    plus: (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 4C8.27614 4 8.5 4.22386 8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4Z"
                fill="#000"
            />
        </svg>
    ),
    minus: (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 8C4 7.72386 4.22386 7.5 4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8Z"
                fill="#000"
            />
        </svg>
    ),
    'plus-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="#000"
            />
            <path
                d="M8 4C8.27614 4 8.5 4.22386 8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4Z"
                fill="#000"
            />
        </svg>
    ),
    'minus-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="#000"
            />
            <path
                d="M4 8C4 7.72386 4.22386 7.5 4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8Z"
                fill="#000"
            />
        </svg>
    ),
    'slash-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="#000"
            />
            <path
                d="M11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645Z"
                fill="#000"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 8C15 11.866 11.866 15 8 15C6.24696 15 4.64443 14.3556 3.41637 13.2907L13.2907 3.41637C14.3556 4.64443 15 6.24696 15 8ZM2.70926 12.5836L12.5836 2.70926C11.3556 1.64441 9.75304 1 8 1C4.13401 1 1 4.13401 1 8C1 9.75304 1.64441 11.3556 2.70926 12.5836ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
                fill="#000"
            />
        </svg>
    ),
    'close-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="#000"
            />
            <path
                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                fill="#000"
            />
        </svg>
    ),
    'check-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
                fill="#000"
            />
            <path
                d="M10.9697 4.96967C10.9626 4.97674 10.9559 4.98423 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967Z"
                fill="#000"
            />
        </svg>
    ),
    'minus-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'plus-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'slash-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L11.3536 5.35355Z"
                fill="#000"
            />
        </svg>
    ),
    'close-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.35355 4.64645C5.15829 4.45118 4.84171 4.45118 4.64645 4.64645C4.45118 4.84171 4.45118 5.15829 4.64645 5.35355L7.29289 8L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L8 8.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6464L8.70711 8L11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L8 7.29289L5.35355 4.64645Z"
                fill="#000"
            />
        </svg>
    ),
    'check-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2626 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.4774 9.41674L5.38388 7.32322C5.09098 7.03033 4.61611 7.03033 4.32322 7.32322C4.03032 7.61612 4.03032 8.09099 4.32322 8.38388L6.96966 11.0303C7.26256 11.3232 7.73743 11.3232 8.03032 11.0303C8.03685 11.0238 8.043 11.0169 8.04876 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
                fill="#000"
            />
        </svg>
    ),
    'minus-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
                fill="#000"
            />
            <path
                d="M4 8C4 7.72386 4.22386 7.5 4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8Z"
                fill="#000"
            />
        </svg>
    ),
    'plus-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
                fill="#000"
            />
            <path
                d="M8 4C8.27614 4 8.5 4.22386 8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4Z"
                fill="#000"
            />
        </svg>
    ),
    'slash-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM14.259 1.03387C14.1764 1.01178 14.0896 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.0896 1.01178 14.1764 1.03387 14.259L14.259 1.03387ZM14.9661 1.74098L1.74098 14.9661C1.82359 14.9882 1.91042 15 2 15H14C14.5523 15 15 14.5523 15 14V2C15 1.91042 14.9882 1.82359 14.9661 1.74098Z"
                fill="#000"
            />
        </svg>
    ),
    'close-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
                fill="#000"
            />
            <path
                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                fill="#000"
            />
        </svg>
    ),
    'check-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 1C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2C1 1.44772 1.44772 1 2 1H14ZM2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2Z"
                fill="#000"
            />
            <path
                d="M10.9697 4.96967C11.2626 4.67678 11.7374 4.67678 12.0303 4.96967C12.3196 5.25897 12.3232 5.72582 12.041 6.01947L8.04876 11.0097C8.043 11.0169 8.03685 11.0238 8.03032 11.0303C7.73743 11.3232 7.26256 11.3232 6.96966 11.0303L4.32322 8.38388C4.03032 8.09099 4.03032 7.61612 4.32322 7.32322C4.61611 7.03033 5.09098 7.03033 5.38388 7.32322L7.4774 9.41674L10.9498 4.9921C10.9559 4.98423 10.9626 4.97674 10.9697 4.96967Z"
                fill="#000"
            />
        </svg>
    ),
    'minus-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM4.5 7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5Z"
                fill="#000"
            />
        </svg>
    ),
    'plus-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM8.5 4.5V7.5H11.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H8.5V11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5H7.5V4.5C7.5 4.22386 7.72386 4 8 4C8.27614 4 8.5 4.22386 8.5 4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'slash-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM11.3536 5.35355L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355Z"
                fill="#000"
            />
        </svg>
    ),
    'close-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645Z"
                fill="#000"
            />
        </svg>
    ),
    'check-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM12.0303 4.96967C12.3196 5.25897 12.3232 5.72582 12.041 6.01947L8.04876 11.0097C8.043 11.0169 8.03685 11.0238 8.03032 11.0303C7.73743 11.3232 7.26256 11.3232 6.96966 11.0303L4.32322 8.38388C4.03032 8.09099 4.03032 7.61612 4.32322 7.32322C4.61611 7.03033 5.09098 7.03033 5.38388 7.32322L7.4774 9.41674L10.9498 4.9921C10.9559 4.98424 10.9626 4.97674 10.9697 4.96967C11.2626 4.67678 11.7374 4.67678 12.0303 4.96967Z"
                fill="#000"
            />
        </svg>
    ),
    'minus-dash-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 0C7.82427 0 7.6498 0.00567341 7.47676 0.0168556L7.54125 1.01477C7.69284 1.00498 7.8458 1 8 1C8.1542 1 8.30716 1.00498 8.45875 1.01477L8.52324 0.0168556C8.3502 0.00567344 8.17573 0 8 0Z"
                fill="#000"
            />
            <path
                d="M6.43925 0.152261C6.09355 0.220651 5.75582 0.311314 5.42763 0.422694L5.74901 1.36965C6.03585 1.2723 6.33106 1.19304 6.63332 1.13325L6.43925 0.152261Z"
                fill="#000"
            />
            <path
                d="M10.5724 0.422694C10.2442 0.311314 9.90645 0.220651 9.56075 0.152262L9.36668 1.13325C9.66894 1.19304 9.96415 1.2723 10.251 1.36965L10.5724 0.422694Z"
                fill="#000"
            />
            <path
                d="M12.4453 1.34778C12.1561 1.1542 11.8536 0.978938 11.5394 0.823676L11.0964 1.72021C11.3712 1.856 11.6359 2.00932 11.889 2.17874L12.4453 1.34778Z"
                fill="#000"
            />
            <path
                d="M4.46063 0.823676C4.14639 0.978938 3.84387 1.1542 3.55472 1.34778L4.11104 2.17874C4.36411 2.00932 4.62878 1.856 4.9036 1.72021L4.46063 0.823676Z"
                fill="#000"
            />
            <path
                d="M2.72505 1.98531C2.46271 2.21556 2.21556 2.46271 1.98531 2.72505L2.73689 3.38469C2.93852 3.15496 3.15496 2.93852 3.38469 2.73689L2.72505 1.98531Z"
                fill="#000"
            />
            <path
                d="M14.0147 2.72505C13.7844 2.46271 13.5373 2.21556 13.275 1.98531L12.6153 2.73689C12.845 2.93852 13.0615 3.15496 13.2631 3.38469L14.0147 2.72505Z"
                fill="#000"
            />
            <path
                d="M15.1763 4.46063C15.0211 4.14639 14.8458 3.84387 14.6522 3.55472L13.8213 4.11104C13.9907 4.36411 14.144 4.62878 14.2798 4.9036L15.1763 4.46063Z"
                fill="#000"
            />
            <path
                d="M1.34778 3.55472C1.1542 3.84387 0.978938 4.14639 0.823676 4.46063L1.72021 4.9036C1.856 4.62878 2.00932 4.36411 2.17874 4.11104L1.34778 3.55472Z"
                fill="#000"
            />
            <path
                d="M0.422694 5.42763C0.311314 5.75582 0.220651 6.09355 0.152262 6.43925L1.13325 6.63332C1.19304 6.33106 1.2723 6.03585 1.36965 5.74901L0.422694 5.42763Z"
                fill="#000"
            />
            <path
                d="M15.8477 6.43925C15.7793 6.09355 15.6887 5.75582 15.5773 5.42763L14.6304 5.74901C14.7277 6.03585 14.807 6.33106 14.8668 6.63332L15.8477 6.43925Z"
                fill="#000"
            />
            <path
                d="M0.0168556 7.47676C0.00567344 7.6498 0 7.82427 0 8C0 8.17573 0.00567341 8.3502 0.0168556 8.52324L1.01477 8.45875C1.00498 8.30716 1 8.1542 1 8C1 7.8458 1.00498 7.69284 1.01477 7.54125L0.0168556 7.47676Z"
                fill="#000"
            />
            <path
                d="M16 8C16 7.82427 15.9943 7.6498 15.9831 7.47676L14.9852 7.54125C14.995 7.69284 15 7.8458 15 8C15 8.1542 14.995 8.30716 14.9852 8.45875L15.9831 8.52324C15.9943 8.3502 16 8.17573 16 8Z"
                fill="#000"
            />
            <path
                d="M0.152261 9.56075C0.220651 9.90645 0.311314 10.2442 0.422694 10.5724L1.36965 10.251C1.2723 9.96415 1.19304 9.66894 1.13325 9.36668L0.152261 9.56075Z"
                fill="#000"
            />
            <path
                d="M15.5773 10.5724C15.6887 10.2442 15.7793 9.90645 15.8477 9.56075L14.8668 9.36668C14.807 9.66894 14.7277 9.96415 14.6304 10.251L15.5773 10.5724Z"
                fill="#000"
            />
            <path
                d="M0.823676 11.5394C0.978938 11.8536 1.1542 12.1561 1.34778 12.4453L2.17874 11.889C2.00932 11.6359 1.856 11.3712 1.72021 11.0964L0.823676 11.5394Z"
                fill="#000"
            />
            <path
                d="M14.6522 12.4453C14.8458 12.1561 15.0211 11.8536 15.1763 11.5394L14.2798 11.0964C14.144 11.3712 13.9907 11.6359 13.8213 11.889L14.6522 12.4453Z"
                fill="#000"
            />
            <path
                d="M1.98531 13.275C2.21556 13.5373 2.46271 13.7844 2.72505 14.0147L3.38469 13.2631C3.15496 13.0615 2.93852 12.845 2.73689 12.6153L1.98531 13.275Z"
                fill="#000"
            />
            <path
                d="M13.275 14.0147C13.5373 13.7844 13.7844 13.5373 14.0147 13.275L13.2631 12.6153C13.0615 12.845 12.845 13.0615 12.6153 13.2631L13.275 14.0147Z"
                fill="#000"
            />
            <path
                d="M11.5394 15.1763C11.8536 15.0211 12.1561 14.8458 12.4453 14.6522L11.889 13.8213C11.6359 13.9907 11.3712 14.144 11.0964 14.2798L11.5394 15.1763Z"
                fill="#000"
            />
            <path
                d="M3.55472 14.6522C3.84387 14.8458 4.14639 15.0211 4.46063 15.1763L4.9036 14.2798C4.62878 14.144 4.36411 13.9907 4.11104 13.8213L3.55472 14.6522Z"
                fill="#000"
            />
            <path
                d="M5.42763 15.5773C5.75582 15.6887 6.09355 15.7793 6.43925 15.8477L6.63332 14.8668C6.33106 14.807 6.03585 14.7277 5.74901 14.6304L5.42763 15.5773Z"
                fill="#000"
            />
            <path
                d="M9.56075 15.8477C9.90645 15.7793 10.2442 15.6887 10.5724 15.5773L10.251 14.6304C9.96415 14.7277 9.66894 14.807 9.36668 14.8668L9.56075 15.8477Z"
                fill="#000"
            />
            <path
                d="M7.47676 15.9831C7.6498 15.9943 7.82427 16 8 16C8.17573 16 8.3502 15.9943 8.52324 15.9831L8.45875 14.9852C8.30716 14.995 8.1542 15 8 15C7.8458 15 7.69284 14.995 7.54125 14.9852L7.47676 15.9831Z"
                fill="#000"
            />
            <path
                d="M4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'plus-dash-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 0C7.82427 0 7.6498 0.00567341 7.47676 0.0168556L7.54125 1.01477C7.69284 1.00498 7.8458 1 8 1C8.1542 1 8.30716 1.00498 8.45875 1.01477L8.52324 0.0168556C8.3502 0.00567344 8.17573 0 8 0Z"
                fill="#000"
            />
            <path
                d="M6.43925 0.152261C6.09355 0.220651 5.75582 0.311314 5.42763 0.422694L5.74901 1.36965C6.03585 1.2723 6.33106 1.19304 6.63332 1.13325L6.43925 0.152261Z"
                fill="#000"
            />
            <path
                d="M10.5724 0.422694C10.2442 0.311314 9.90645 0.220651 9.56075 0.152262L9.36668 1.13325C9.66894 1.19304 9.96415 1.2723 10.251 1.36965L10.5724 0.422694Z"
                fill="#000"
            />
            <path
                d="M12.4453 1.34778C12.1561 1.1542 11.8536 0.978938 11.5394 0.823676L11.0964 1.72021C11.3712 1.856 11.6359 2.00932 11.889 2.17874L12.4453 1.34778Z"
                fill="#000"
            />
            <path
                d="M4.46063 0.823676C4.14639 0.978938 3.84387 1.1542 3.55472 1.34778L4.11104 2.17874C4.36411 2.00932 4.62878 1.856 4.9036 1.72021L4.46063 0.823676Z"
                fill="#000"
            />
            <path
                d="M2.72505 1.98531C2.46271 2.21556 2.21556 2.46271 1.98531 2.72505L2.73689 3.38469C2.93852 3.15496 3.15496 2.93852 3.38469 2.73689L2.72505 1.98531Z"
                fill="#000"
            />
            <path
                d="M14.0147 2.72505C13.7844 2.46271 13.5373 2.21556 13.275 1.98531L12.6153 2.73689C12.845 2.93852 13.0615 3.15496 13.2631 3.38469L14.0147 2.72505Z"
                fill="#000"
            />
            <path
                d="M15.1763 4.46063C15.0211 4.14639 14.8458 3.84387 14.6522 3.55472L13.8213 4.11104C13.9907 4.36411 14.144 4.62878 14.2798 4.9036L15.1763 4.46063Z"
                fill="#000"
            />
            <path
                d="M1.34778 3.55472C1.1542 3.84387 0.978938 4.14639 0.823676 4.46063L1.72021 4.9036C1.856 4.62878 2.00932 4.36411 2.17874 4.11104L1.34778 3.55472Z"
                fill="#000"
            />
            <path
                d="M0.422694 5.42763C0.311314 5.75582 0.220651 6.09355 0.152262 6.43925L1.13325 6.63332C1.19304 6.33106 1.2723 6.03585 1.36965 5.74901L0.422694 5.42763Z"
                fill="#000"
            />
            <path
                d="M15.8477 6.43925C15.7793 6.09355 15.6887 5.75582 15.5773 5.42763L14.6304 5.74901C14.7277 6.03585 14.807 6.33106 14.8668 6.63332L15.8477 6.43925Z"
                fill="#000"
            />
            <path
                d="M0.0168556 7.47676C0.00567344 7.6498 0 7.82427 0 8C0 8.17573 0.00567341 8.3502 0.0168556 8.52324L1.01477 8.45875C1.00498 8.30716 1 8.1542 1 8C1 7.8458 1.00498 7.69284 1.01477 7.54125L0.0168556 7.47676Z"
                fill="#000"
            />
            <path
                d="M16 8C16 7.82427 15.9943 7.6498 15.9831 7.47676L14.9852 7.54125C14.995 7.69284 15 7.8458 15 8C15 8.1542 14.995 8.30716 14.9852 8.45875L15.9831 8.52324C15.9943 8.3502 16 8.17573 16 8Z"
                fill="#000"
            />
            <path
                d="M0.152261 9.56075C0.220651 9.90645 0.311314 10.2442 0.422694 10.5724L1.36965 10.251C1.2723 9.96415 1.19304 9.66894 1.13325 9.36668L0.152261 9.56075Z"
                fill="#000"
            />
            <path
                d="M15.5773 10.5724C15.6887 10.2442 15.7793 9.90645 15.8477 9.56075L14.8668 9.36668C14.807 9.66894 14.7277 9.96415 14.6304 10.251L15.5773 10.5724Z"
                fill="#000"
            />
            <path
                d="M0.823676 11.5394C0.978938 11.8536 1.1542 12.1561 1.34778 12.4453L2.17874 11.889C2.00932 11.6359 1.856 11.3712 1.72021 11.0964L0.823676 11.5394Z"
                fill="#000"
            />
            <path
                d="M14.6522 12.4453C14.8458 12.1561 15.0211 11.8536 15.1763 11.5394L14.2798 11.0964C14.144 11.3712 13.9907 11.6359 13.8213 11.889L14.6522 12.4453Z"
                fill="#000"
            />
            <path
                d="M1.98531 13.275C2.21556 13.5373 2.46271 13.7844 2.72505 14.0147L3.38469 13.2631C3.15496 13.0615 2.93852 12.845 2.73689 12.6153L1.98531 13.275Z"
                fill="#000"
            />
            <path
                d="M13.275 14.0147C13.5373 13.7844 13.7844 13.5373 14.0147 13.275L13.2631 12.6153C13.0615 12.845 12.845 13.0615 12.6153 13.2631L13.275 14.0147Z"
                fill="#000"
            />
            <path
                d="M11.5394 15.1763C11.8536 15.0211 12.1561 14.8458 12.4453 14.6522L11.889 13.8213C11.6359 13.9907 11.3712 14.144 11.0964 14.2798L11.5394 15.1763Z"
                fill="#000"
            />
            <path
                d="M3.55472 14.6522C3.84387 14.8458 4.14639 15.0211 4.46063 15.1763L4.9036 14.2798C4.62878 14.144 4.36411 13.9907 4.11104 13.8213L3.55472 14.6522Z"
                fill="#000"
            />
            <path
                d="M5.42763 15.5773C5.75582 15.6887 6.09355 15.7793 6.43925 15.8477L6.63332 14.8668C6.33106 14.807 6.03585 14.7277 5.74901 14.6304L5.42763 15.5773Z"
                fill="#000"
            />
            <path
                d="M9.56075 15.8477C9.90645 15.7793 10.2442 15.6887 10.5724 15.5773L10.251 14.6304C9.96415 14.7277 9.66894 14.807 9.36668 14.8668L9.56075 15.8477Z"
                fill="#000"
            />
            <path
                d="M7.47676 15.9831C7.6498 15.9943 7.82427 16 8 16C8.17573 16 8.3502 15.9943 8.52324 15.9831L8.45875 14.9852C8.30716 14.995 8.1542 15 8 15C7.8458 15 7.69284 14.995 7.54125 14.9852L7.47676 15.9831Z"
                fill="#000"
            />
            <path
                d="M8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'minus-dash-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.5 0C2.33368 0 2.17067 0.0163118 2.01264 0.0475742L2.20671 1.02856C2.30117 1.00988 2.39918 1 2.5 1H2.95833V0H2.5Z"
                fill="#000"
            />
            <path d="M4.79167 0H3.875V1H4.79167V0Z" fill="#000" />
            <path d="M6.625 0H5.70833V1H6.625V0Z" fill="#000" />
            <path d="M8.45833 0H7.54167V1H8.45833V0Z" fill="#000" />
            <path d="M10.2917 0H9.375V1H10.2917V0Z" fill="#000" />
            <path d="M12.125 0H11.2083V1H12.125V0Z" fill="#000" />
            <path
                d="M13.5 0H13.0417V1H13.5C13.6008 1 13.6988 1.00988 13.7933 1.02856L13.9874 0.0475741C13.8293 0.0163118 13.6663 0 13.5 0Z"
                fill="#000"
            />
            <path
                d="M15.5786 1.11061C15.3962 0.838196 15.1618 0.603761 14.8894 0.421385L14.3331 1.25235C14.4969 1.36201 14.638 1.50314 14.7476 1.66693L15.5786 1.11061Z"
                fill="#000"
            />
            <path
                d="M1.11061 0.421385C0.838196 0.603761 0.603761 0.838196 0.421385 1.11061L1.25235 1.66693C1.36201 1.50314 1.50314 1.36201 1.66693 1.25235L1.11061 0.421385Z"
                fill="#000"
            />
            <path
                d="M16 2.5C16 2.33368 15.9837 2.17067 15.9524 2.01264L14.9714 2.20671C14.9901 2.30117 15 2.39918 15 2.5V2.95833H16V2.5Z"
                fill="#000"
            />
            <path
                d="M0.0475741 2.01264C0.0163118 2.17067 0 2.33368 0 2.5V2.95833H1V2.5C1 2.39918 1.00988 2.30117 1.02856 2.20671L0.0475741 2.01264Z"
                fill="#000"
            />
            <path d="M0 3.875V4.79167H1V3.875H0Z" fill="#000" />
            <path d="M16 4.79167V3.875H15V4.79167H16Z" fill="#000" />
            <path d="M0 5.70833V6.625H1V5.70833H0Z" fill="#000" />
            <path d="M16 6.625V5.70833H15V6.625H16Z" fill="#000" />
            <path d="M0 7.54167V8.45833H1V7.54167H0Z" fill="#000" />
            <path d="M15 8.45833H16V7.54167H15V8.45833Z" fill="#000" />
            <path d="M0 9.375V10.2917H1V9.375H0Z" fill="#000" />
            <path d="M16 10.2917V9.375H15V10.2917H16Z" fill="#000" />
            <path d="M0 11.2083V12.125H1V11.2083H0Z" fill="#000" />
            <path d="M16 12.125V11.2083H15V12.125H16Z" fill="#000" />
            <path
                d="M0 13.0417V13.5C0 13.6663 0.0163118 13.8293 0.0475742 13.9874L1.02856 13.7933C1.00988 13.6988 1 13.6008 1 13.5V13.0417H0Z"
                fill="#000"
            />
            <path
                d="M16 13.5V13.0417H15V13.5C15 13.6008 14.9901 13.6988 14.9714 13.7933L15.9524 13.9874C15.9837 13.8293 16 13.6663 16 13.5Z"
                fill="#000"
            />
            <path
                d="M0.421385 14.8894C0.603761 15.1618 0.838196 15.3962 1.11061 15.5786L1.66693 14.7476C1.50314 14.638 1.36201 14.4969 1.25235 14.3331L0.421385 14.8894Z"
                fill="#000"
            />
            <path
                d="M14.8894 15.5786C15.1618 15.3962 15.3962 15.1618 15.5786 14.8894L14.7476 14.3331C14.638 14.4969 14.4969 14.638 14.3331 14.7476L14.8894 15.5786Z"
                fill="#000"
            />
            <path
                d="M2.01264 15.9524C2.17067 15.9837 2.33368 16 2.5 16H2.95833V15H2.5C2.39918 15 2.30117 14.9901 2.20671 14.9714L2.01264 15.9524Z"
                fill="#000"
            />
            <path
                d="M13.5 16C13.6663 16 13.8293 15.9837 13.9874 15.9524L13.7933 14.9714C13.6988 14.9901 13.6008 15 13.5 15H13.0417V16H13.5Z"
                fill="#000"
            />
            <path d="M3.875 16H4.79167V15H3.875V16Z" fill="#000" />
            <path d="M5.70833 16H6.625V15H5.70833V16Z" fill="#000" />
            <path d="M7.54167 16H8.45833V15H7.54167V16Z" fill="#000" />
            <path d="M9.375 16H10.2917V15H9.375V16Z" fill="#000" />
            <path d="M11.2083 16H12.125V15H11.2083V16Z" fill="#000" />
            <path
                d="M4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'plus-dash-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.5 0C2.33368 0 2.17067 0.0163118 2.01264 0.0475742L2.20671 1.02856C2.30117 1.00988 2.39918 1 2.5 1H2.95833V0H2.5Z"
                fill="#000"
            />
            <path d="M4.79167 0H3.875V1H4.79167V0Z" fill="#000" />
            <path d="M6.625 0H5.70833V1H6.625V0Z" fill="#000" />
            <path d="M8.45833 0H7.54167V1H8.45833V0Z" fill="#000" />
            <path d="M10.2917 0H9.375V1H10.2917V0Z" fill="#000" />
            <path d="M12.125 0H11.2083V1H12.125V0Z" fill="#000" />
            <path
                d="M13.5 0H13.0417V1H13.5C13.6008 1 13.6988 1.00988 13.7933 1.02856L13.9874 0.0475741C13.8293 0.0163118 13.6663 0 13.5 0Z"
                fill="#000"
            />
            <path
                d="M15.5786 1.11061C15.3962 0.838196 15.1618 0.603761 14.8894 0.421385L14.3331 1.25235C14.4969 1.36201 14.638 1.50314 14.7476 1.66693L15.5786 1.11061Z"
                fill="#000"
            />
            <path
                d="M1.11061 0.421385C0.838196 0.603761 0.603761 0.838196 0.421385 1.11061L1.25235 1.66693C1.36201 1.50314 1.50314 1.36201 1.66693 1.25235L1.11061 0.421385Z"
                fill="#000"
            />
            <path
                d="M16 2.5C16 2.33368 15.9837 2.17067 15.9524 2.01264L14.9714 2.20671C14.9901 2.30117 15 2.39918 15 2.5V2.95833H16V2.5Z"
                fill="#000"
            />
            <path
                d="M0.0475741 2.01264C0.0163118 2.17067 0 2.33368 0 2.5V2.95833H1V2.5C1 2.39918 1.00988 2.30117 1.02856 2.20671L0.0475741 2.01264Z"
                fill="#000"
            />
            <path d="M0 3.875V4.79167H1V3.875H0Z" fill="#000" />
            <path d="M16 4.79167V3.875H15V4.79167H16Z" fill="#000" />
            <path d="M0 5.70833V6.625H1V5.70833H0Z" fill="#000" />
            <path d="M16 6.625V5.70833H15V6.625H16Z" fill="#000" />
            <path d="M0 7.54167V8.45833H1V7.54167H0Z" fill="#000" />
            <path d="M15 8.45833H16V7.54167H15V8.45833Z" fill="#000" />
            <path d="M0 9.375V10.2917H1V9.375H0Z" fill="#000" />
            <path d="M16 10.2917V9.375H15V10.2917H16Z" fill="#000" />
            <path d="M0 11.2083V12.125H1V11.2083H0Z" fill="#000" />
            <path d="M16 12.125V11.2083H15V12.125H16Z" fill="#000" />
            <path
                d="M0 13.0417V13.5C0 13.6663 0.0163118 13.8293 0.0475742 13.9874L1.02856 13.7933C1.00988 13.6988 1 13.6008 1 13.5V13.0417H0Z"
                fill="#000"
            />
            <path
                d="M16 13.5V13.0417H15V13.5C15 13.6008 14.9901 13.6988 14.9714 13.7933L15.9524 13.9874C15.9837 13.8293 16 13.6663 16 13.5Z"
                fill="#000"
            />
            <path
                d="M0.421385 14.8894C0.603761 15.1618 0.838196 15.3962 1.11061 15.5786L1.66693 14.7476C1.50314 14.638 1.36201 14.4969 1.25235 14.3331L0.421385 14.8894Z"
                fill="#000"
            />
            <path
                d="M14.8894 15.5786C15.1618 15.3962 15.3962 15.1618 15.5786 14.8894L14.7476 14.3331C14.638 14.4969 14.4969 14.638 14.3331 14.7476L14.8894 15.5786Z"
                fill="#000"
            />
            <path
                d="M2.01264 15.9524C2.17067 15.9837 2.33368 16 2.5 16H2.95833V15H2.5C2.39918 15 2.30117 14.9901 2.20671 14.9714L2.01264 15.9524Z"
                fill="#000"
            />
            <path
                d="M13.5 16C13.6663 16 13.8293 15.9837 13.9874 15.9524L13.7933 14.9714C13.6988 14.9901 13.6008 15 13.5 15H13.0417V16H13.5Z"
                fill="#000"
            />
            <path d="M3.875 16H4.79167V15H3.875V16Z" fill="#000" />
            <path d="M5.70833 16H6.625V15H5.70833V16Z" fill="#000" />
            <path d="M7.54167 15V16H8.45833V15H7.54167Z" fill="#000" />
            <path d="M9.375 16H10.2917V15H9.375V16Z" fill="#000" />
            <path d="M11.2083 16H12.125V15H11.2083V16Z" fill="#000" />
            <path
                d="M8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'close-octagon': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.53984 0.146447C4.63361 0.0526784 4.76079 0 4.8934 0H11.1066C11.2392 0 11.3664 0.0526784 11.4602 0.146447L15.8536 4.53984C15.9473 4.63361 16 4.76079 16 4.8934V11.1066C16 11.2392 15.9473 11.3664 15.8536 11.4602L11.4602 15.8536C11.3664 15.9473 11.2392 16 11.1066 16H4.8934C4.76079 16 4.63361 15.9473 4.53984 15.8536L0.146447 11.4602C0.0526784 11.3664 0 11.2392 0 11.1066V4.8934C0 4.76079 0.0526784 4.63361 0.146447 4.53984L4.53984 0.146447ZM5.1005 1L1 5.1005V10.8995L5.10051 15H10.8995L15 10.8995V5.10051L10.8995 1H5.1005Z"
                fill="#000"
            />
            <path
                d="M4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645Z"
                fill="#000"
            />
        </svg>
    ),
    'close-octagon-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.4602 0.146447C11.3664 0.0526784 11.2392 0 11.1066 0H4.8934C4.76079 0 4.63361 0.0526784 4.53984 0.146447L0.146447 4.53984C0.0526784 4.63361 0 4.76079 0 4.8934V11.1066C0 11.2392 0.0526784 11.3664 0.146447 11.4602L4.53984 15.8536C4.63361 15.9473 4.76079 16 4.8934 16H11.1066C11.2392 16 11.3664 15.9473 11.4602 15.8536L15.8536 11.4602C15.9473 11.3664 16 11.2392 16 11.1066V4.8934C16 4.76079 15.9473 4.63361 15.8536 4.53984L11.4602 0.146447ZM5.35355 4.64645L8 7.29289L10.6464 4.64645C10.8417 4.45118 11.1583 4.45118 11.3536 4.64645C11.5488 4.84171 11.5488 5.15829 11.3536 5.35355L8.70711 8L11.3536 10.6464C11.5488 10.8417 11.5488 11.1583 11.3536 11.3536C11.1583 11.5488 10.8417 11.5488 10.6464 11.3536L8 8.70711L5.35355 11.3536C5.15829 11.5488 4.84171 11.5488 4.64645 11.3536C4.45118 11.1583 4.45118 10.8417 4.64645 10.6464L7.29289 8L4.64645 5.35355C4.45118 5.15829 4.45118 4.84171 4.64645 4.64645C4.84171 4.45118 5.15829 4.45118 5.35355 4.64645Z"
                fill="#000"
            />
        </svg>
    ),
    backspace: (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.82937 5.14645C5.63411 5.34171 5.63411 5.65829 5.82937 5.85355L7.97582 8L5.82937 10.1464C5.63411 10.3417 5.63411 10.6583 5.82937 10.8536C6.02463 11.0488 6.34121 11.0488 6.53648 10.8536L8.68292 8.70711L10.8294 10.8536C11.0246 11.0488 11.3412 11.0488 11.5365 10.8536C11.7317 10.6583 11.7317 10.3417 11.5365 10.1464L9.39003 8L11.5365 5.85355C11.7317 5.65829 11.7317 5.34171 11.5365 5.14645C11.3412 4.95118 11.0246 4.95118 10.8294 5.14645L8.68292 7.29289L6.53648 5.14645C6.34121 4.95118 6.02463 4.95118 5.82937 5.14645Z"
                fill="#000"
            />
            <path
                d="M13.6829 1C14.7875 1 15.6829 1.89543 15.6829 3V13C15.6829 14.1046 14.7875 15 13.6829 15H6.60279C6.01894 15 5.46424 14.7449 5.08428 14.3016L0.240744 8.65079C-0.0802479 8.2763 -0.0802479 7.7237 0.240744 7.34921L5.08428 1.69842C5.46424 1.25513 6.01894 1 6.60279 1H13.6829ZM6.60279 2C6.31087 2 6.03352 2.12756 5.84354 2.34921L1 8L5.84354 13.6508C6.03352 13.8724 6.31087 14 6.60279 14H13.6829C14.2352 14 14.6829 13.5523 14.6829 13V3C14.6829 2.44772 14.2352 2 13.6829 2H6.60279Z"
                fill="#000"
            />
        </svg>
    ),
    'backspace-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.6829 3C15.6829 1.89543 14.7875 1 13.6829 1H6.60279C6.01894 1 5.46424 1.25513 5.08428 1.69842L0.240744 7.34921C-0.0802479 7.7237 -0.0802479 8.2763 0.240744 8.65079L5.08428 14.3016C5.46424 14.7449 6.01894 15 6.60279 15H13.6829C14.7875 15 15.6829 14.1046 15.6829 13V3ZM5.82937 5.85355C5.63411 5.65829 5.63411 5.34171 5.82937 5.14645C6.02463 4.95118 6.34121 4.95118 6.53648 5.14645L8.68292 7.29289L10.8294 5.14645C11.0246 4.95118 11.3412 4.95118 11.5365 5.14645C11.7317 5.34171 11.7317 5.65829 11.5365 5.85355L9.39003 8L11.5365 10.1464C11.7317 10.3417 11.7317 10.6583 11.5365 10.8536C11.3412 11.0488 11.0246 11.0488 10.8294 10.8536L8.68292 8.70711L6.53648 10.8536C6.34121 11.0488 6.02463 11.0488 5.82937 10.8536C5.63411 10.6583 5.63411 10.3417 5.82937 10.1464L7.97582 8L5.82937 5.85355Z"
                fill="#000"
            />
        </svg>
    ),
    'backspace-reverse': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.85355 5.14645C10.0488 5.34171 10.0488 5.65829 9.85355 5.85355L7.70711 8L9.85355 10.1464C10.0488 10.3417 10.0488 10.6583 9.85355 10.8536C9.65829 11.0488 9.34171 11.0488 9.14645 10.8536L7 8.70711L4.85355 10.8536C4.65829 11.0488 4.34171 11.0488 4.14645 10.8536C3.95118 10.6583 3.95118 10.3417 4.14645 10.1464L6.29289 8L4.14645 5.85355C3.95118 5.65829 3.95118 5.34171 4.14645 5.14645C4.34171 4.95118 4.65829 4.95118 4.85355 5.14645L7 7.29289L9.14645 5.14645C9.34171 4.95118 9.65829 4.95118 9.85355 5.14645Z"
                fill="#000"
            />
            <path
                d="M2 1C0.895431 1 0 1.89543 0 3V13C0 14.1046 0.89543 15 2 15H9.08013C9.66398 15 10.2187 14.7449 10.5986 14.3016L15.4422 8.65079C15.7632 8.2763 15.7632 7.7237 15.4422 7.34921L10.5986 1.69842C10.2187 1.25513 9.66398 1 9.08013 1H2ZM9.08013 2C9.37206 2 9.6494 2.12756 9.83939 2.34921L14.6829 8L9.83939 13.6508C9.6494 13.8724 9.37206 14 9.08013 14H2C1.44772 14 1 13.5523 1 13V3C1 2.44772 1.44772 2 2 2H9.08013Z"
                fill="#000"
            />
        </svg>
    ),
    'backspace-reverse-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 3C0 1.89543 0.895431 1 2 1H9.08013C9.66398 1 10.2187 1.25513 10.5986 1.69842L15.4422 7.34921C15.7632 7.7237 15.7632 8.2763 15.4422 8.65079L10.5986 14.3016C10.2187 14.7449 9.66398 15 9.08013 15H2C0.89543 15 0 14.1046 0 13V3ZM9.85355 5.85355C10.0488 5.65829 10.0488 5.34171 9.85355 5.14645C9.65829 4.95118 9.34171 4.95118 9.14645 5.14645L7 7.29289L4.85355 5.14645C4.65829 4.95118 4.34171 4.95118 4.14645 5.14645C3.95118 5.34171 3.95118 5.65829 4.14645 5.85355L6.29289 8L4.14645 10.1464C3.95118 10.3417 3.95118 10.6583 4.14645 10.8536C4.34171 11.0488 4.65829 11.0488 4.85355 10.8536L7 8.70711L9.14645 10.8536C9.34171 11.0488 9.65829 11.0488 9.85355 10.8536C10.0488 10.6583 10.0488 10.3417 9.85355 10.1464L7.70711 8L9.85355 5.85355Z"
                fill="#000"
            />
        </svg>
    ),
    'check2-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C9.00262 2.5 9.94117 2.76782 10.7496 3.2355C10.9887 3.37377 11.2945 3.29209 11.4328 3.05306C11.5711 2.81403 11.4894 2.50816 11.2504 2.36989C10.2938 1.81654 9.1831 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 7.72386 14.2761 7.5 14 7.5C13.7239 7.5 13.5 7.72386 13.5 8C13.5 11.0376 11.0376 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8Z"
                fill="#000"
            />
            <path
                d="M15.3536 3.35355C15.5488 3.15829 15.5488 2.84171 15.3536 2.64645C15.1583 2.45118 14.8417 2.45118 14.6464 2.64645L8 9.29289L5.35355 6.64645C5.15829 6.45118 4.84171 6.45118 4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355L7.64645 10.3536C7.84171 10.5488 8.15829 10.5488 8.35355 10.3536L15.3536 3.35355Z"
                fill="#000"
            />
        </svg>
    ),
    'check2-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3 14.5C2.17157 14.5 1.5 13.8284 1.5 13V3C1.5 2.17157 2.17157 1.5 3 1.5H11C11.2761 1.5 11.5 1.72386 11.5 2C11.5 2.27614 11.2761 2.5 11 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V8C13.5 7.72386 13.7239 7.5 14 7.5C14.2761 7.5 14.5 7.72386 14.5 8V13C14.5 13.8284 13.8284 14.5 13 14.5H3Z"
                fill="#000"
            />
            <path
                d="M8.35355 10.3536L15.3536 3.35355C15.5488 3.15829 15.5488 2.84171 15.3536 2.64645C15.1583 2.45118 14.8417 2.45118 14.6464 2.64645L8 9.29289L5.35355 6.64645C5.15829 6.45118 4.84171 6.45118 4.64645 6.64645C4.45118 6.84171 4.45118 7.15829 4.64645 7.35355L7.64645 10.3536C7.84171 10.5488 8.15829 10.5488 8.35355 10.3536Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-bottom': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4C8.27614 4 8.5 4.22386 8.5 4.5V10.2929L10.6464 8.14645C10.8417 7.95118 11.1583 7.95118 11.3536 8.14645C11.5488 8.34171 11.5488 8.65829 11.3536 8.85355L8.35355 11.8536C8.15829 12.0488 7.84171 12.0488 7.64645 11.8536L4.64645 8.85355C4.45118 8.65829 4.45118 8.34171 4.64645 8.14645C4.84171 7.95118 5.15829 7.95118 5.35355 8.14645L7.5 10.2929V4.5C7.5 4.22386 7.72386 4 8 4Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-top': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 12C8.27614 12 8.5 11.7761 8.5 11.5V5.70711L10.6464 7.85355C10.8417 8.04882 11.1583 8.04882 11.3536 7.85355C11.5488 7.65829 11.5488 7.34171 11.3536 7.14645L8.35355 4.14645C8.15829 3.95118 7.84171 3.95118 7.64645 4.14645L4.64645 7.14645C4.45118 7.34171 4.45118 7.65829 4.64645 7.85355C4.84171 8.04882 5.15829 8.04882 5.35355 7.85355L7.5 5.70711V11.5C7.5 11.7761 7.72386 12 8 12Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-left': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 8C12 8.27614 11.7761 8.5 11.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5H11.5C11.7761 7.5 12 7.72386 12 8Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-right': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 8C4 7.72386 4.22386 7.5 4.5 7.5H10.2929L8.14645 5.35355C7.95118 5.15829 7.95118 4.84171 8.14645 4.64645C8.34171 4.45118 8.65829 4.45118 8.85355 4.64645L11.8536 7.64645C12.0488 7.84171 12.0488 8.15829 11.8536 8.35355L8.85355 11.3536C8.65829 11.5488 8.34171 11.5488 8.14645 11.3536C7.95118 11.1583 7.95118 10.8417 8.14645 10.6464L10.2929 8.5H4.5C4.22386 8.5 4 8.27614 4 8Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V10.2929L5.35355 8.14645C5.15829 7.95118 4.84171 7.95118 4.64645 8.14645C4.45118 8.34171 4.45118 8.65829 4.64645 8.85355L7.64645 11.8536C7.84171 12.0488 8.15829 12.0488 8.35355 11.8536L11.3536 8.85355C11.5488 8.65829 11.5488 8.34171 11.3536 8.14645C11.1583 7.95118 10.8417 7.95118 10.6464 8.14645L8.5 10.2929V4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-left-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.5 7.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5H11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-right-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H10.2929L8.14645 10.6464C7.95118 10.8417 7.95118 11.1583 8.14645 11.3536C8.34171 11.5488 8.65829 11.5488 8.85355 11.3536L11.8536 8.35355C12.0488 8.15829 12.0488 7.84171 11.8536 7.64645L8.85355 4.64645C8.65829 4.45118 8.34171 4.45118 8.14645 4.64645C7.95118 4.84171 7.95118 5.15829 8.14645 5.35355L10.2929 7.5H4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-left-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.0962 10.8033C10.2915 10.9986 10.608 10.9986 10.8033 10.8033C10.9986 10.608 10.9986 10.2914 10.8033 10.0962L6.70711 5.99999L9.47483 5.99999C9.75098 5.99999 9.97484 5.77614 9.97484 5.49999C9.97484 5.22385 9.75098 4.99999 9.47483 4.99999L5.5 4.99999C5.22386 4.99999 5 5.22385 5 5.49999L5 9.47487C5 9.75101 5.22386 9.97487 5.5 9.97487C5.77614 9.97487 6 9.75101 6 9.47487L6 6.7071L10.0962 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-right-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.85354 10.8033C5.65828 10.9986 5.3417 10.9986 5.14644 10.8033C4.95117 10.608 4.95117 10.2914 5.14644 10.0962L9.24263 5.99999L6.4749 5.99999C6.19876 5.99999 5.9749 5.77614 5.9749 5.49999C5.9749 5.22385 6.19876 4.99999 6.4749 4.99999L10.4497 4.99999C10.7259 4.99999 10.9497 5.22385 10.9497 5.49999V9.47487C10.9497 9.75101 10.7259 9.97487 10.4497 9.97487C10.1736 9.97487 9.94974 9.75101 9.94974 9.47487L9.94974 6.7071L5.85354 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-right-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.85354 5.14645C5.65828 4.95118 5.3417 4.95118 5.14644 5.14645C4.95117 5.34171 4.95117 5.65829 5.14644 5.85355L9.24263 9.94975L6.4749 9.94974C6.19876 9.94974 5.9749 10.1736 5.9749 10.4497C5.9749 10.7259 6.19876 10.9497 6.4749 10.9497L10.4497 10.9497C10.7259 10.9497 10.9497 10.7259 10.9497 10.4497V6.47487C10.9497 6.19872 10.7259 5.97487 10.4497 5.97487C10.1736 5.97487 9.94974 6.19872 9.94974 6.47487L9.94974 9.24264L5.85354 5.14645Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-left-circle': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.0962 5.14645C10.2915 4.95118 10.608 4.95118 10.8033 5.14645C10.9986 5.34171 10.9986 5.65829 10.8033 5.85355L6.70711 9.94975L9.47483 9.94974C9.75098 9.94974 9.97484 10.1736 9.97484 10.4497C9.97484 10.7259 9.75098 10.9497 9.47483 10.9497L5.5 10.9497C5.22386 10.9497 5 10.7259 5 10.4497L5 6.47487C5 6.19872 5.22386 5.97487 5.5 5.97487C5.77614 5.97487 6 6.19872 6 6.47487L6 9.24264L10.0962 5.14645Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V10.2929L5.35355 8.14645C5.15829 7.95118 4.84171 7.95118 4.64645 8.14645C4.45118 8.34171 4.45118 8.65829 4.64645 8.85355L7.64645 11.8536C7.84171 12.0488 8.15829 12.0488 8.35355 11.8536L11.3536 8.85355C11.5488 8.65829 11.5488 8.34171 11.3536 8.14645C11.1583 7.95118 10.8417 7.95118 10.6464 8.14645L8.5 10.2929V4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM8.5 11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-left-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM11.5 7.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5H11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-right-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H10.2929L8.14645 10.6464C7.95118 10.8417 7.95118 11.1583 8.14645 11.3536C8.34171 11.5488 8.65829 11.5488 8.85355 11.3536L11.8536 8.35355C12.0488 8.15829 12.0488 7.84171 11.8536 7.64645L8.85355 4.64645C8.65829 4.45118 8.34171 4.45118 8.14645 4.64645C7.95118 4.84171 7.95118 5.15829 8.14645 5.35355L10.2929 7.5H4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-left-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10.0962 10.8033C10.2915 10.9986 10.608 10.9986 10.8033 10.8033C10.9986 10.608 10.9986 10.2914 10.8033 10.0962L6.70711 5.99999L9.47483 5.99999C9.75098 5.99999 9.97484 5.77614 9.97484 5.49999C9.97484 5.22385 9.75098 4.99999 9.47483 4.99999L5.5 4.99999C5.22386 4.99999 5 5.22385 5 5.49999L5 9.47487C5 9.75101 5.22386 9.97487 5.5 9.97487C5.77614 9.97487 6 9.75101 6 9.47487L6 6.7071L10.0962 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-right-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8ZM5.9038 10.8033C5.70854 10.9986 5.39196 10.9986 5.1967 10.8033C5.00144 10.608 5.00144 10.2914 5.1967 10.0962L9.29289 5.99999L6.52517 5.99999C6.24902 5.99999 6.02516 5.77614 6.02516 5.49999C6.02516 5.22385 6.24902 4.99999 6.52517 4.99999L10.5 4.99999C10.7761 4.99999 11 5.22385 11 5.49999V9.47487C11 9.75101 10.7761 9.97487 10.5 9.97487C10.2239 9.97487 10 9.75101 10 9.47487L10 6.7071L5.9038 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-right-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM5.9038 5.19671C5.70854 5.00145 5.39196 5.00145 5.1967 5.19671C5.00144 5.39197 5.00144 5.70855 5.1967 5.90382L9.29289 10L6.52517 10C6.24902 10 6.02516 10.2239 6.02516 10.5C6.02516 10.7761 6.24902 11 6.52517 11L10.5 11C10.7761 11 11 10.7762 11 10.5V6.52513C11 6.24899 10.7761 6.02513 10.5 6.02513C10.2239 6.02513 10 6.24899 10 6.52513L10 9.2929L5.9038 5.19671Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-left-circle-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM10.0962 5.19671C10.2915 5.00145 10.608 5.00145 10.8033 5.19671C10.9986 5.39197 10.9986 5.70855 10.8033 5.90382L6.70711 10L9.47483 10C9.75098 10 9.97484 10.2239 9.97484 10.5C9.97484 10.7761 9.75098 11 9.47483 11L5.5 11C5.22386 11 5 10.7762 5 10.5V6.52513C5 6.24899 5.22386 6.02513 5.5 6.02513C5.77614 6.02513 6 6.24899 6 6.52513L6 9.2929L10.0962 5.19671Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V10.2929L5.35355 8.14645C5.15829 7.95118 4.84171 7.95118 4.64645 8.14645C4.45118 8.34171 4.45118 8.65829 4.64645 8.85355L7.64645 11.8536C7.84171 12.0488 8.15829 12.0488 8.35355 11.8536L11.3536 8.85355C11.5488 8.65829 11.5488 8.34171 11.3536 8.14645C11.1583 7.95118 10.8417 7.95118 10.6464 8.14645L8.5 10.2929V4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM8.5 11.5C8.5 11.7761 8.27614 12 8 12C7.72386 12 7.5 11.7761 7.5 11.5V5.70711L5.35355 7.85355C5.15829 8.04882 4.84171 8.04882 4.64645 7.85355C4.45118 7.65829 4.45118 7.34171 4.64645 7.14645L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645L11.3536 7.14645C11.5488 7.34171 11.5488 7.65829 11.3536 7.85355C11.1583 8.04882 10.8417 8.04882 10.6464 7.85355L8.5 5.70711V11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-left-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM11.5 7.5C11.7761 7.5 12 7.72386 12 8C12 8.27614 11.7761 8.5 11.5 8.5H5.70711L7.85355 10.6464C8.04882 10.8417 8.04882 11.1583 7.85355 11.3536C7.65829 11.5488 7.34171 11.5488 7.14645 11.3536L4.14645 8.35355C3.95118 8.15829 3.95118 7.84171 4.14645 7.64645L7.14645 4.64645C7.34171 4.45118 7.65829 4.45118 7.85355 4.64645C8.04882 4.84171 8.04882 5.15829 7.85355 5.35355L5.70711 7.5H11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-right-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM4.5 7.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H10.2929L8.14645 10.6464C7.95118 10.8417 7.95118 11.1583 8.14645 11.3536C8.34171 11.5488 8.65829 11.5488 8.85355 11.3536L11.8536 8.35355C12.0488 8.15829 12.0488 7.84171 11.8536 7.64645L8.85355 4.64645C8.65829 4.45118 8.34171 4.45118 8.14645 4.64645C7.95118 4.84171 7.95118 5.15829 8.14645 5.35355L10.2929 7.5H4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-left-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM10.0962 10.8033C10.2915 10.9986 10.608 10.9986 10.8033 10.8033C10.9986 10.608 10.9986 10.2914 10.8033 10.0962L6.70711 5.99999L9.47483 5.99999C9.75098 5.99999 9.97484 5.77614 9.97484 5.49999C9.97484 5.22385 9.75098 4.99999 9.47483 4.99999L5.5 4.99999C5.22386 4.99999 5 5.22385 5 5.49999L5 9.47487C5 9.75101 5.22386 9.97487 5.5 9.97487C5.77614 9.97487 6 9.75101 6 9.47487L6 6.7071L10.0962 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-right-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM5.85354 10.8033C5.65828 10.9986 5.3417 10.9986 5.14644 10.8033C4.95117 10.608 4.95117 10.2914 5.14644 10.0962L9.24263 5.99999L6.4749 5.99999C6.19876 5.99999 5.9749 5.77614 5.9749 5.49999C5.9749 5.22385 6.19876 4.99999 6.4749 4.99999L10.4497 4.99999C10.7259 4.99999 10.9497 5.22385 10.9497 5.49999V9.47487C10.9497 9.75101 10.7259 9.97487 10.4497 9.97487C10.1736 9.97487 9.94974 9.75101 9.94974 9.47487L9.94974 6.7071L5.85354 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-right-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM5.85354 5.14645C5.65828 4.95118 5.3417 4.95118 5.14644 5.14645C4.95117 5.34171 4.95117 5.65829 5.14644 5.85355L9.24263 9.94975L6.4749 9.94974C6.19876 9.94974 5.9749 10.1736 5.9749 10.4497C5.9749 10.7259 6.19876 10.9497 6.4749 10.9497L10.4497 10.9497C10.7259 10.9497 10.9497 10.7259 10.9497 10.4497V6.47487C10.9497 6.19872 10.7259 5.97487 10.4497 5.97487C10.1736 5.97487 9.94974 6.19872 9.94974 6.47487L9.94974 9.24264L5.85354 5.14645Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-left-square': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15 1.44772 14.5523 1 14 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V2ZM0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2ZM10.0962 5.14645C10.2915 4.95118 10.608 4.95118 10.8033 5.14645C10.9986 5.34171 10.9986 5.65829 10.8033 5.85355L6.70711 9.94975L9.47483 9.94974C9.75098 9.94974 9.97484 10.1736 9.97484 10.4497C9.97484 10.7259 9.75098 10.9497 9.47483 10.9497L5.5 10.9497C5.22386 10.9497 5 10.7259 5 10.4497L5 6.47487C5 6.19872 5.22386 5.97487 5.5 5.97487C5.77614 5.97487 6 6.19872 6 6.47487L6 9.24264L10.0962 5.14645Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM8.5 4.5V10.2929L10.6464 8.14645C10.8417 7.95118 11.1583 7.95118 11.3536 8.14645C11.5488 8.34171 11.5488 8.65829 11.3536 8.85355L8.35355 11.8536C8.15829 12.0488 7.84171 12.0488 7.64645 11.8536L4.64645 8.85355C4.45118 8.65829 4.45118 8.34171 4.64645 8.14645C4.84171 7.95118 5.15829 7.95118 5.35355 8.14645L7.5 10.2929V4.5C7.5 4.22386 7.72386 4 8 4C8.27614 4 8.5 4.22386 8.5 4.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 16C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2ZM8.5 11.5V5.70711L10.6464 7.85355C10.8417 8.04882 11.1583 8.04882 11.3536 7.85355C11.5488 7.65829 11.5488 7.34171 11.3536 7.14645L8.35355 4.14645C8.15829 3.95118 7.84171 3.95118 7.64645 4.14645L4.64645 7.14645C4.45118 7.34171 4.45118 7.65829 4.64645 7.85355C4.84171 8.04882 5.15829 8.04882 5.35355 7.85355L7.5 5.70711V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-left-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 16C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2ZM8.5 11.5V5.70711L10.6464 7.85355C10.8417 8.04882 11.1583 8.04882 11.3536 7.85355C11.5488 7.65829 11.5488 7.34171 11.3536 7.14645L8.35355 4.14645C8.15829 3.95118 7.84171 3.95118 7.64645 4.14645L4.64645 7.14645C4.45118 7.34171 4.45118 7.65829 4.64645 7.85355C4.84171 8.04882 5.15829 8.04882 5.35355 7.85355L7.5 5.70711V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-right-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2C0.895431 0 0 0.895431 0 2V14ZM4.5 7.5H10.2929L8.14645 5.35355C7.95118 5.15829 7.95118 4.84171 8.14645 4.64645C8.34171 4.45118 8.65829 4.45118 8.85355 4.64645L11.8536 7.64645C12.0488 7.84171 12.0488 8.15829 11.8536 8.35355L8.85355 11.3536C8.65829 11.5488 8.34171 11.5488 8.14645 11.3536C7.95118 11.1583 7.95118 10.8417 8.14645 10.6464L10.2929 8.5H4.5C4.22386 8.5 4 8.27614 4 8C4 7.72386 4.22386 7.5 4.5 7.5Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-left-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2ZM10.0962 10.8033L6 6.7071L6 9.47487C6 9.75101 5.77614 9.97487 5.5 9.97487C5.22386 9.97487 5 9.75101 5 9.47487L5 5.49999C5 5.22385 5.22386 4.99999 5.5 4.99999L9.47483 4.99999C9.75098 4.99999 9.97484 5.22385 9.97484 5.49999C9.97484 5.77614 9.75098 5.99999 9.47483 5.99999L6.70711 5.99999L10.8033 10.0962C10.9986 10.2914 10.9986 10.608 10.8033 10.8033C10.608 10.9986 10.2915 10.9986 10.0962 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-up-right-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 0C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14ZM5.9038 10.8033L10 6.7071L10 9.47487C10 9.75101 10.2239 9.97487 10.5 9.97487C10.7761 9.97487 11 9.75101 11 9.47487V5.49999C11 5.22385 10.7761 4.99999 10.5 4.99999L6.52517 4.99999C6.24902 4.99999 6.02516 5.22385 6.02516 5.49999C6.02516 5.77614 6.24902 5.99999 6.52517 5.99999L9.29289 5.99999L5.1967 10.0962C5.00144 10.2914 5.00144 10.608 5.1967 10.8033C5.39196 10.9986 5.70854 10.9986 5.9038 10.8033Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-right-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 16C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0H2C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14ZM5.9038 5.19671L10 9.2929L10 6.52513C10 6.24899 10.2239 6.02513 10.5 6.02513C10.7761 6.02513 11 6.24899 11 6.52513V10.5C11 10.7762 10.7761 11 10.5 11L6.52517 11C6.24902 11 6.02516 10.7761 6.02516 10.5C6.02516 10.2239 6.24902 10 6.52517 10L9.29289 10L5.1967 5.90382C5.00144 5.70855 5.00144 5.39197 5.1967 5.19671C5.39196 5.00145 5.70854 5.00145 5.9038 5.19671Z"
                fill="#000"
            />
        </svg>
    ),
    'arrow-down-left-square-fill': (
        <svg width="24" height="24" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 16C0.895431 16 0 15.1046 0 14V2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2ZM10.0962 5.19671L6 9.2929L6 6.52513C6 6.24899 5.77614 6.02513 5.5 6.02513C5.22386 6.02513 5 6.24899 5 6.52513L5 10.5C5 10.7762 5.22386 11 5.5 11L9.47483 11C9.75098 11 9.97484 10.7761 9.97484 10.5C9.97484 10.2239 9.75098 10 9.47483 10L6.70711 10L10.8033 5.90382C10.9986 5.70855 10.9986 5.39197 10.8033 5.19671C10.608 5.00145 10.2915 5.00145 10.0962 5.19671Z"
                fill="#000"
            />
        </svg>
    ),
    'thumb-down': (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8.864 15.674c-.956.24-1.843-.484-1.908-1.42-.072-1.05-.23-2.015-.428-2.59-.125-.36-.479-1.012-1.04-1.638-.557-.624-1.282-1.179-2.131-1.41C2.685 8.432 2 7.85 2 7V3c0-.845.682-1.464 1.448-1.546 1.07-.113 1.564-.415 2.068-.723l.048-.029c.272-.166.578-.349.97-.484C6.931.08 7.395 0 8 0h3.5c.937 0 1.599.478 1.934 1.064.164.287.254.607.254.913 0 .152-.023.312-.077.464.201.262.38.577.488.9.11.33.172.762.004 1.15.069.13.12.268.159.403.077.27.113.567.113.856s-.036.586-.113.856c-.035.12-.08.244-.138.363.394.571.418 1.2.234 1.733-.206.592-.682 1.1-1.2 1.272-.847.283-1.803.276-2.516.211a10 10 0 0 1-.443-.05 9.36 9.36 0 0 1-.062 4.51c-.138.508-.55.848-1.012.964zM11.5 1H8c-.51 0-.863.068-1.14.163-.281.097-.506.229-.776.393l-.04.025c-.555.338-1.198.73-2.49.868-.333.035-.554.29-.554.55V7c0 .255.226.543.62.65 1.095.3 1.977.997 2.614 1.709.635.71 1.064 1.475 1.238 1.977.243.7.407 1.768.482 2.85.025.362.36.595.667.518l.262-.065c.16-.04.258-.144.288-.255a8.34 8.34 0 0 0-.145-4.726.5.5 0 0 1 .595-.643h.003l.014.004.058.013a9 9 0 0 0 1.036.157c.663.06 1.457.054 2.11-.163.175-.059.45-.301.57-.651.107-.308.087-.67-.266-1.021L12.793 7l.353-.354c.043-.042.105-.14.154-.315.048-.167.075-.37.075-.581s-.027-.414-.075-.581c-.05-.174-.111-.273-.154-.315l-.353-.354.353-.354c.047-.047.109-.176.005-.488a2.2 2.2 0 0 0-.505-.804l-.353-.354.353-.354c.006-.005.041-.05.041-.17a.9.9 0 0 0-.121-.415C12.4 1.272 12.063 1 11.5 1" />
        </svg>
    ),
    'thumb-up': (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8.864.046C7.908-.193 7.02.53 6.956 1.466c-.072 1.051-.23 2.016-.428 2.59-.125.36-.479 1.013-1.04 1.639-.557.623-1.282 1.178-2.131 1.41C2.685 7.288 2 7.87 2 8.72v4.001c0 .845.682 1.464 1.448 1.545 1.07.114 1.564.415 2.068.723l.048.03c.272.165.578.348.97.484.397.136.861.217 1.466.217h3.5c.937 0 1.599-.477 1.934-1.064a1.86 1.86 0 0 0 .254-.912c0-.152-.023-.312-.077-.464.201-.263.38-.578.488-.901.11-.33.172-.762.004-1.149.069-.13.12-.269.159-.403.077-.27.113-.568.113-.857 0-.288-.036-.585-.113-.856a2 2 0 0 0-.138-.362 1.9 1.9 0 0 0 .234-1.734c-.206-.592-.682-1.1-1.2-1.272-.847-.282-1.803-.276-2.516-.211a10 10 0 0 0-.443.05 9.4 9.4 0 0 0-.062-4.509A1.38 1.38 0 0 0 9.125.111zM11.5 14.721H8c-.51 0-.863-.069-1.14-.164-.281-.097-.506-.228-.776-.393l-.04-.024c-.555-.339-1.198-.731-2.49-.868-.333-.036-.554-.29-.554-.55V8.72c0-.254.226-.543.62-.65 1.095-.3 1.977-.996 2.614-1.708.635-.71 1.064-1.475 1.238-1.978.243-.7.407-1.768.482-2.85.025-.362.36-.594.667-.518l.262.066c.16.04.258.143.288.255a8.34 8.34 0 0 1-.145 4.725.5.5 0 0 0 .595.644l.003-.001.014-.003.058-.014a9 9 0 0 1 1.036-.157c.663-.06 1.457-.054 2.11.164.175.058.45.3.57.65.107.308.087.67-.266 1.022l-.353.353.353.354c.043.043.105.141.154.315.048.167.075.37.075.581 0 .212-.027.414-.075.582-.05.174-.111.272-.154.315l-.353.353.353.354c.047.047.109.177.005.488a2.2 2.2 0 0 1-.505.805l-.353.353.353.354c.006.005.041.05.041.17a.9.9 0 0 1-.121.416c-.165.288-.503.56-1.066.56z" />
        </svg>
    )
};

export default ICONS;
